import styled from "@emotion/styled";

export const DialogTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 15px;
`;

export const DialogMessage = styled.p`
  margin: 0 0 20px 0;
  font-size: 1rem;
  color: #333;
`;

export const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  gap: 12px;
`;
